import React, {useEffect, useState} from "react"
import ThemeFormWizard from "../../../components/form/ThemeFormWizard";
import {useGetThemeAssetsQuery, useGetThemesQuery, useUpdateThemeMutation} from "../../../../../../redux/apiSlice";
import Skeleton from "react-loading-skeleton";
import {useSubheader} from "../../../../../../_metronic/layout";
import cogoToast from "cogo-toast";

export const EditTheme = ({match, location, history}) => {
    const [tab, setTab] = useState(1);

    const {themeDetails} = useGetThemesQuery(match?.params?.userGroup, {
        selectFromResult: ({data}) => ({
            themeDetails: data?.find((theme) => theme.id === match.params.themeId),
        }),
    })

    const subheader = useSubheader();

    useEffect(() => {
        subheader.setTitle(themeDetails?.name || <Skeleton count="1" width={"100px"}/>)
    }, [themeDetails])

    const {data: themeAssets} = useGetThemeAssetsQuery(match?.params?.themeId)

    const [
        updateTheme, // This is the mutation trigger
        {isLoading: isUpdating, isSuccess: updateSuccessful}, // This is the destructured mutation result
    ] = useUpdateThemeMutation()

    /* Clear fields on success */
    useEffect(() => {
        if(updateSuccessful) {
            cogoToast.success("Created 'Theme Update' Action Successfully")
            history.push(`/themes/view/${match.params.userGroup}/${match.params.themeId}`)
        }
    }, [history, updateSuccessful, match.params.themeId, match.params.userGroup]);

    /* Submit user Data */
    const submitData = async data => {
        const assets = []
        for (const assetId of Object.keys(data.assets || {})) {
            assets.push({id: assetId})
        }

        updateTheme({
            id: match.params.themeId,
            name: data.name,
            userGroup: data.userGroup,
            description: data.description,
            status: data.status,
            assets,
            metadata: themeDetails
        })
    }

    return (!themeAssets || !themeDetails)
        ? <div className="container">
            <div className="card card-custom card-white pb-5">
                <center>
                    <Skeleton height={50} count={3} width="20%" style={{margin: "2rem 2rem 5rem 2rem"}}/>
                    <Skeleton height={30} width="40%" count={8} style={{margin: "1rem 5%"}}/>
                </center>
            </div>
        </div>
        : <ThemeFormWizard
            key={location.key}
            tab={tab} // Reset Tab on success
            data={{assets: themeAssets, ...themeDetails}}
            setTab={setTab}
            isLoading={isUpdating}
            submitData={submitData}
            includeImageFields={false}
        />
}